import { RefObject, useCallback, useEffect, useRef, useState } from 'react';

type Position = 'right' | 'left';

const DEFAULT_SIDER_WIDTH = 400;

export function useResizerSidebar(
  position: Position,
  initialWidth?: number,
): [RefObject<HTMLDivElement>, () => void, number] {
  const sidebarRef = useRef<HTMLDivElement>(null);
  const [isResizing, setIsResizing] = useState(false);
  const [sidebarWidth, setSidebarWidth] = useState(initialWidth ?? DEFAULT_SIDER_WIDTH);

  const startResizing = () => {
    setIsResizing(true);
  };

  const stopResizing = () => {
    setIsResizing(false);
  };

  const resize = useCallback(
    (e: MouseEvent) => {
      if (!isResizing) { return; }
      if (position === 'right') {
        const right = sidebarRef?.current?.getBoundingClientRect().right;
        if (!right && right !== 0) { return; }
        setSidebarWidth(right - e.clientX);
        return;
      }
      const x = sidebarRef?.current?.getBoundingClientRect().x;
      if (!x && x !== 0) { return; }
      setSidebarWidth(e.clientX - x);
    },
    [isResizing],
  );

  useEffect(() => {
    window.addEventListener('mousemove', resize);
    window.addEventListener('mouseup', stopResizing);
    return () => {
      window.removeEventListener('mousemove', resize);
      window.removeEventListener('mouseup', stopResizing);
    };
  }, [resize, stopResizing]);

  return [sidebarRef, startResizing, sidebarWidth];
}
